import React, {Component} from 'react';
import {Route, Routes} from "react-router-dom";

import Home from './Home';
import About from './About';
import Games from './Games';
import Toys from './Toys';
import RAndD from './RAndD';
import Animations from './Animations';
import Resume from './Resume';
import AR from './AR';
//import TextToSpeech from './TextToSpeech';
      
class Content extends Component{
  render(){
    return(
      <div className="content">
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/about" element={<About/>}/>        
          <Route path="/games" element={<Games/>}/>
          <Route path="/toys" element={<Toys/>}/>
          <Route path="/rAndD" element={<RAndD/>}/>
          <Route path="/animations" element={<Animations/>}/>
          <Route path="/resume" element={<Resume/>}/>
          <Route path="/AR" element={<AR/>}/>
        </Routes>
      </div>
    );
  }
}

export default Content;
